import React, {useContext} from 'react'


const SettingsContext = React.createContext({})

export const useSettings = () => {
  return useContext(SettingsContext)
}

export default SettingsContext